import { useState } from 'react';
import { ArrowLeft, FileText, BarChart3, Users, ScrollText, Settings, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { StatsTab } from './StatsTab';
import { AdvancedPromptsTab } from './AdvancedPromptsTab';
import { AdminPlans } from './AdminPlans';
import { UsersTab } from './UsersTab';
import { LogsTab } from './LogsTab';
import { MailingTab } from './MailingTab';
import { AdminSettingsTab } from './AdminSettingsTab';

interface AdminDashboardProps {
    onBack: () => void;
}

type TabType = 'prompts' | 'stats' | 'users' | 'logs' | 'plans' | 'mailing' | 'settings';

export function AdminDashboard({ onBack }: AdminDashboardProps) {
    const [activeTab, setActiveTab] = useState<TabType>('stats');

    const tabs: { id: TabType; label: string; icon: React.ReactNode }[] = [
        { id: 'stats', label: 'Statystyki', icon: <BarChart3 className="w-4 h-4" /> },
        { id: 'plans', label: 'Plany', icon: <FileText className="w-4 h-4" /> },
        { id: 'prompts', label: 'Prompty', icon: <FileText className="w-4 h-4" /> },
        { id: 'users', label: 'Użytkownicy', icon: <Users className="w-4 h-4" /> },
        { id: 'logs', label: 'Logi', icon: <ScrollText className="w-4 h-4" /> },
        { id: 'mailing', label: 'Mailing', icon: <Mail className="w-4 h-4" /> },
        { id: 'settings', label: 'Ustawienia', icon: <Settings className="w-4 h-4" /> },
    ];

    return (
        <div className="min-h-screen bg-background">
            {/* Header */}
            <div className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-10">
                <div className="max-w-7xl mx-auto px-4 py-4">
                    <div className="flex items-center gap-4">
                        <Button variant="ghost" size="icon" onClick={onBack}>
                            <ArrowLeft className="w-5 h-5" />
                        </Button>
                        <h1 className="text-2xl font-bold">Panel Administratora</h1>
                    </div>

                    {/* Tabs */}
                    <div className="flex gap-1 mt-4">
                        {tabs.map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${activeTab === tab.id
                                    ? 'bg-primary text-primary-foreground'
                                    : 'text-muted-foreground hover:bg-muted'
                                    }`}
                            >
                                {tab.icon}
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-7xl mx-auto px-4 py-6">
                {activeTab === 'stats' && <StatsTab />}
                {activeTab === 'plans' && <AdminPlans />}
                {activeTab === 'prompts' && <AdvancedPromptsTab />}
                {activeTab === 'users' && <UsersTab />}
                {activeTab === 'logs' && <LogsTab />}
                {activeTab === 'mailing' && <MailingTab />}
                {activeTab === 'settings' && <AdminSettingsTab />}
            </div>
        </div>
    );
}

export default AdminDashboard;
